import { BooleanInput } from '@angular/cdk/coercion';
import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from 'app/Common/common.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
  imports: [MatButtonModule, MatMenuModule, NgIf, MatIconModule, MatDividerModule, TranslatePipe, RouterModule],
})
export class UserComponent implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user_name: string = '';
    user_email: string = '';
  company_name: string = '';
  client_name: string = '';
    profile_photo: string = '';
    role_permissions: any;
  type: number = 0;
  ges_system: boolean = false;
  theme_mode = "light";
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
      private _commonService: CommonService,
    )
    {
      this.user_name = this._commonService.user_name;
      this.user_email = this._commonService.email_id;
      this.profile_photo = this._commonService.profile_photo;
      if (this._commonService.admin_id > 0) {
        this.company_name = this._commonService.company_name;
        this.client_name = this._commonService.client_name;
      }

      this.theme_mode = localStorage.getItem("themeMode");
      if (this.theme_mode != "dark") {
        this.theme_mode = "light";
      }

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
      this._commonService.onUserProfileUpdated
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(data => {

          if (data == true) {
            this.user_name =  this._commonService.user_name;
            this.user_email = this._commonService.email_id;
            this.profile_photo = this._commonService.profile_photo;
            if (this._commonService.admin_id > 0) {
              this.company_name = this._commonService.company_name;
              this.client_name = this._commonService.client_name;
            }
            this._changeDetectorRef.markForCheck();

          }
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    SetThemeMode(colorMode): void {

      localStorage.setItem("themeMode", colorMode);
      location.reload();
    }

    LogOut(): void {
      localStorage.removeItem("jwt");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("jwt_last_refresh");
      sessionStorage.removeItem('current_user');
      window.location.href = "/login";

    }


  
}
